




















































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import { MobileGetter } from 'frontend/types';

@Component({
  computed: {
    ...mapGetters('pageHeader', ['isMobile']),
  },
})
export default class Summary extends Vue {
  @Prop({ type: Boolean, default: false }) private readonly isBelowFold!: boolean;

  private isMobile!: MobileGetter;
}
